module.exports = require("././ui-utils.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-utils (bower component)
// module id = 384
// module chunks = 0